module.exports = __webpack_public_path__ + "img/b_Mukoleks_border.9f2826d4.jpeg";